$component-class: 'sn-related-search-terms-type-1';

// Section (same as me-section)
.#{$component-class} {
  width: 100%;
}

// Container: same as me-container (margin, horizontal padding, max-width) + vertical gap 2xl / 5xl on desktop
.#{$component-class}__container {
  margin: 0 auto;
  padding: var(--spacing-2xl) var(--spacing-md) var(--spacing-2xl) var(--spacing-md);
  max-width: 1312px;

  @media (width >= 768px) {
    padding-top: var(--spacing-5xl);
    padding-bottom: var(--spacing-5xl);
  }
}

// Header
.#{$component-class}__header {
  // no extra styles
}

// Heading: me-heading variant 2, center (heading-2-sm 2.25rem, heading-2-lg 3rem, line-height 120%, bold, margin-bottom)
.#{$component-class}__heading {
  margin: 0 0 var(--spacing-md);
  font-style: normal;
  letter-spacing: normal;
  -webkit-font-smoothing: antialiased;
  font-weight: 700;
  text-align: center;
  font-size: 2.25rem;
  line-height: 1.2;

  @media (width >= 768px) {
    font-size: 3rem;
  }
}

.#{$component-class}__header:last-child .#{$component-class}__heading,
.#{$component-class}__heading:last-child {
  margin-bottom: 0;
}

// List (same as related-search-terms-type-1__tags-list)
.#{$component-class}__list {
  margin-top: calc(var(--spacing-6xl) - var(--spacing-xs));
  margin-bottom: calc(-1 * var(--spacing-xs));
}

// Item (same as tags-list-item)
.#{$component-class}__item {
  display: inline-flex;
  margin: var(--spacing-xs);
}

// Tag: same look as me-tag (CSS variables only)
.#{$component-class}__tag {
  display: inline-flex;
  color: var(--text-color-primary);
  font-size: var(--font-size-md, 1rem);
  line-height: var(--line-height-md, 1.5);
  font-weight: 600;
  background-color: var(--background-color-secondary);
  border-radius: var(--radius-size-md);
  padding: var(--spacing-2xs) var(--spacing-xs);
  user-select: none;
  text-decoration: none;
}
